import logo from './logo.svg';
import './App.css';
// import HomePage from './Pages/HomePage/HomePage';
import AdvanceSearch from './Pages/AdvanceSearch/AdvanceSearch';
import FilterJobs from './Pages/FilterJobs/FilterJobs';
import MainRoutes from './Components/MainRoutes';
import Signup from './Pages/Signup/Signup';
import Login from './Pages/Login/Login';
import Signup2 from './Pages/Signup/Signup2';
import ServicePackage from './Pages/ServicePackage/ServicePackage';
import Cart from './Pages/Cart/Cart';
import Service from './Pages/PremiumServices/Service';
import Employee from './Components/Employee';
import TabButton from './Components/SeviceCard';

function App() {
  return (
    <div className="App">
      
   <MainRoutes/>
      
      
    </div>
  );
}

export default App;
